// extracted by mini-css-extract-plugin
export default {"ConfirmPageBlock":"ConfirmPage_ConfirmPageBlock__MT9XK","buttons":"ConfirmPage_buttons__9x6A7"};